import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiPaginationResponseDataNonNullable } from "app/shared/models/api-response.model";
import { Observable } from "rxjs";
import { AuthService } from "../../base-module/base-service/auth.service";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { ClientEquityModelV2, ClientEquityPositionRefreshResponse } from "../models/client-equity.model";

@Injectable()
export class ClientEquityService {
    constructor(private authService: AuthService, private _http: HttpClient, public utilitesService: UtilitesService) {}

    /**
     * Lista de Histório do Cliente
     * @param id ID da Histório do Cliente
     */
    getAll(params: any): Observable<ApiPaginationResponseDataNonNullable<ClientEquityModelV2>> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }

        return this._http.get<ApiPaginationResponseDataNonNullable<ClientEquityModelV2>>(
            this.utilitesService.urlPrefix + "clientes/equity/position" + env,
            { headers: this.authService.getAuthHeaders() }
        );
    }

    /**
     * Lista de Histório do Cliente
     * @param id ID da Histório do Cliente
     */
    getVariation(params: any): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "clientes/equity/variation" + env, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de Histório do Cliente
     * @param id ID da Histório do Cliente
     */
    getVariationYear(params: any): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "clientes/equity/variation-year" + env, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de Histório do Cliente
     * @param id ID da Histório do Cliente
     */
    getAllDateHistoryInvestiments(params: any): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "clientes/equity/history" + env, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de Histório do Cliente
     * @param id ID da Histório do Cliente
     */
    getAllMovimentEquity(params: any): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "movimentacao/produtos" + env, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de Histório do Cliente
     * @param id ID da Histório do Cliente
     */
    getLastUpdate(): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "clientes/equity/last-update", {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Atualiza posições de equity do cliente
     * @param clienteId ID do cliente para atualizar posições
     */
    refreshPosition(clienteId: number): Observable<ClientEquityPositionRefreshResponse> {
        const params = { cliente_id: clienteId };
        const paramHttp = this.utilitesService.formurlencoded(params);
        const env = paramHttp ? "?" + paramHttp : "";

        return this._http.get<ClientEquityPositionRefreshResponse>(
            this.utilitesService.urlPrefix + "clientes/equity/position/refresh" + env,
            { headers: this.authService.getAuthHeaders() }
        );
    }
}
